<template>
  <div class="terms-page">
    <div class="page-header parallaxie">
		<div class="container">
			<div class="row align-items-center">
				<div class="col-lg-12">
					<!-- Page Header Box Start -->
					<div class="page-header-box">
						<h1 class="wow fadeInUp" data-cursor="-opaque">Terminos y condiciones</h1>
						<nav class="wow fadeInUp" data-wow-delay="0.2s">
                            <ol class="breadcrumb">
								<li class="breadcrumb-item active" aria-current="page"> Lea atentamente los siguientes términos antes de utilizar nuestro sitio web y servicios.</li>
							</ol>
						</nav>
					</div>
					<!-- Page Header Box End -->
				</div>
			</div>
		</div>
	</div>
    <div class="container">
      <!-- Section Title Start -->
      <div class="section-title section-title-center">
        <p class="wow fadeInUp" data-wow-delay="0.2s">
         
        </p>
      </div>
      <!-- Section Title End -->

      <!-- Terms Content Start -->
      <div class="terms-content wow fadeInUp" data-wow-delay="0.4s">
        <h4>1. Aceptación de los términos</h4>
        <p>Al utilizar el sitio web de <strong>MAP Tecnología y Seguridad</strong>, usted acepta los presentes términos y condiciones, así como cualquier modificación futura publicada en el sitio.</p>

        <h4>2. Uso del sitio</h4>
        <p>El usuario se compromete a usar el sitio de manera responsable, sin infringir leyes locales, nacionales o internacionales, ni los derechos de terceros.</p>

        <h4>3. Servicios ofrecidos</h4>
        <p><strong>MAP Tecnología y Seguridad</strong> proporciona servicios de seguridad electrónica, CCTV, alarmas, control de acceso, GPS vehicular y redes. Toda información publicada en el sitio tiene fines informativos y puede estar sujeta a cambios sin previo aviso.</p>

        <h4>4. Responsabilidad</h4>
        <p>Aunque nos esforzamos por brindar información precisa, <strong>MAP Tecnología y Seguridad</strong> no se hace responsable de daños, pérdidas o inconvenientes derivados del uso del sitio web o de los servicios contratados.</p>

        <h4>5. Propiedad intelectual</h4>
        <p>Todo el contenido del sitio web, incluyendo textos, imágenes, logotipos y software, es propiedad de <strong>MAP Tecnología y Seguridad</strong> o de sus respectivos autores, y está protegido por leyes de propiedad intelectual.</p>

        <h4>6. Modificaciones de los términos</h4>
        <p>Nos reservamos el derecho de actualizar o modificar estos términos en cualquier momento. El uso continuado del sitio implica la aceptación de dichos cambios.</p>

        <h4>7. Ley aplicable y jurisdicción</h4>
        <p>Estos términos se rigen por las leyes de México. Cualquier disputa relacionada con el sitio web será resuelta ante los tribunales competentes del país.</p>

        <h4>Contacto</h4>
        <p>Para dudas o consultas sobre estos términos y condiciones, puede escribirnos a: <a href="mailto:ventas@mapseguridadmx.com">ventas@mapseguridadmx.com</a></p>
      </div>
      <!-- Terms Content End -->
    </div>
  </div>
</template>

<script>
export default {
  name: "Terms"
};
</script>
